export const ENTER = 13;
export const SPACE = 32;
export const ESCAPE = 27;
export const TAB = 9;
export const BACKSPACE = 8;

// Arrow keys
export const DOWN = 40;
export const UP = 38;
export const LEFT = 37;
export const RIGHT = 39;

export enum keyCodes {
    ENTER = 13,
    SPACE = 32,
    ESCAPE = 27,
    TAB = 9,
    BACKSPACE = 8,

    DOWN = 40,
    UP = 38,
    LEFT = 37,
    RIGHT = 39,
}
